import type { ReactElement } from 'react';
import { Notice } from '../ops/shared';
import { Button } from '../ui';
import { problemText } from './problems';
import a from './Admin.module.css';

/** A page of a list that didn't load, in words, with a way to ask again. */
export function ListError({
  what,
  error,
  onRetry,
}: {
  /** What was being read, as a noun phrase: "The people". */
  what: string;
  error: unknown;
  onRetry: () => void;
}): ReactElement {
  return (
    <>
      <Notice tone="problem">
        <strong>{what} didn’t load.</strong> {problemText(error)}
      </Notice>
      <div className={a.toolbar}>
        <Button variant="ghost" size="sm" onPress={onRetry}>
          Try again
        </Button>
      </div>
    </>
  );
}
